export enum SearchCategory {
  NEWS = 'econews',
  EVENTS = 'events'
}
